export class User {
    public id: string;
    public email: string;
    public pass: string;
    public HashedPass: string;
    public admin: boolean;
    public authorizedPathIDs: string[]; // this is the path the user is authorized to go

    constructor(obj: any) {
        this.id = obj.ID;
        this.email = obj.Email;
        this.pass = obj.Pass;
        this.admin = obj.Admin;
        this.authorizedPathIDs = obj.AuthorizedPathIDs;
        this.HashedPass = obj.HashedPass;
    }
}
